// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import createTypedReducer, { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

type HeaderState = Readonly<{
    isSticky: boolean;
    headerLinkListLinks: [];
}>;

const initialHeaderState: HeaderState = {
    isSticky: false,
    headerLinkListLinks: [],
};

const reducer = {
    "xHeader/isSticky": (draft: Draft<HeaderState>, action: { isSticky: boolean }) => {
        draft.isSticky = action.isSticky;
    },
    "xHeader/setHeaderLinkListLinks": (draft: Draft<HeaderState>, action: { headerLinkListLinks: [] }) => {
        draft.headerLinkListLinks = action.headerLinkListLinks;
    },
};

const xHeader = createTypedReducerWithImmer(initialHeaderState, reducer);

(reducers as any).xHeader = xHeader;

export type xHeaderState = {
    xHeader: HeaderState;
};

type xHeaderReducers = {
    isSticky: typeof xHeader;
    setHeaderLinkListLinks: typeof xHeader;
};

export type xHeaderActions = Parameters<xHeaderReducers[keyof xHeaderReducers]>[1] | AnyAction;
